export function getFormattedFileSize(size: number | null | undefined) {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  if (!size) {
    return 'n/a';
  }

  const i = Math.floor(Math.log(size) / Math.log(1024));

  if (i === 0) {
    return size + ' ' + sizes[i];
  }

  return (size / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
}
